<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action" :class="{hide: card.action === '' }"><p v-html="card.action"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Team',
  data () {
    return {
      cards: [{
        title: 'group.ingesup.title',
        img: {link: 'static/img/team_work.png', alt: 'group.ingesup.alt.pict'},
        desc: 'group.ingesup.desc',
        action: ''
      }, {
        title: 'group.iut.title',
        img: {link: 'static/img/team_work.png', alt: 'group.iut.alt.pict'},
        desc: 'group.iut.desc',
        action: ''
      }, {
        title: 'group.highschool.title',
        img: {link: 'static/img/team_work.png', alt: 'group.highschool.alt.pict'},
        desc: 'group.highschool.desc',
        action: ''
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Team.vue